var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddsection(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51299 12.8334L11.535 17.8734C11.6837 17.9564 11.8511 18.0001 12.0214 18.0003C12.1916 18.0004 12.3591 17.9571 12.508 17.8744L21.486 12.8744C21.6419 12.7877 21.7719 12.6608 21.8622 12.5069C21.9526 12.3531 22.0002 12.1778 22 11.9993C21.9998 11.8209 21.9518 11.6457 21.8611 11.4921C21.7703 11.3384 21.6401 11.2118 21.484 11.1254L12.462 6.12543C12.3139 6.04333 12.1474 6.00018 11.9781 6C11.8088 5.99983 11.6422 6.04264 11.494 6.12443L2.51599 11.0844C2.35978 11.1707 2.22951 11.2972 2.13869 11.4509C2.04787 11.6045 1.99982 11.7796 1.99951 11.958C1.99921 12.1365 2.04666 12.3118 2.13695 12.4657C2.22724 12.6196 2.35708 12.7466 2.51299 12.8334Z",
    fill: "#808080"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.48516 15.126L2.51416 16.874L11.5142 21.874C11.6627 21.9565 11.8298 21.9998 11.9997 21.9998C12.1695 21.9998 12.3366 21.9565 12.4852 21.874L21.4852 16.874L20.5142 15.126L12.0002 19.856L3.48516 15.126ZM20.0002 8V6H22.0002V4H20.0002V2H18.0002V4H16.0002V6H18.0002V8H20.0002Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddsection);
export default __webpack_public_path__ + "static/media/addsection.d8eee5fa3f929dfe89c85ed4818faa27.svg";
export { ForwardRef as ReactComponent };